// AVISO DE VERSÃO NOVA.
//
// O problema real, medido em 04/09/2026: o jogo ficou aberto na tela (ou no
// app) desde antes de uma publicação, e continuou rodando o JavaScript velho.
// Duas funções novas — a parada nos intervalos e o mercado ativo — pareciam
// não existir, e não havia nada na tela dizendo o contrário. Recarregar
// resolvia, mas ninguém tem por que adivinhar isso.
//
// ⚠️ A recarga automática existe, mas com DUAS travas — sem elas ela é pior
// que o problema que resolve:
//
//   1. Só recarrega quando não há nada em andamento (`ocupado()`). Recarregar
//      no meio de uma partida ao vivo perde a partida: ela só vira campanha
//      quando termina. O resto do jogo é gravado no localStorage a cada ação,
//      então recarregar fora dali não custa nada.
//   2. UMA recarga por versão publicada, marcada no sessionStorage. Se a
//      comparação der errado — o build novo continuar se anunciando diferente
//      —, sem esta trava a aba entraria num laço de recarga. Com ela, o pior
//      caso é uma recarga inútil e o aviso na tela.
//
// O aviso continua existindo para quem está ocupado, e para o caso de o
// sessionStorage estar bloqueado.

const META = 'build-meta.json';

/** A marca da versão que ESTÁ rodando agora, gravada no build. */
export const VERSAO_ATUAL = typeof __BUILD__ === 'string' ? __BUILD__ : 'dev';

/**
 * Pergunta ao servidor qual versão está publicada.
 *
 * O `?t=` existe para furar cache: sem ele, a própria checagem viria do cache
 * e responderia para sempre que está tudo em dia — o defeito verificando a si
 * mesmo.
 */
async function versaoPublicada() {
  try {
    const base = (import.meta.env?.BASE_URL || './').replace(/\/$/, '');
    const r = await fetch(`${base}/${META}?t=${Date.now()}`, { cache: 'no-store' });
    if (!r.ok) return null;
    const j = await r.json();
    return typeof j?.build === 'string' ? j.build : null;
  } catch {
    return null;   // sem rede: não é assunto para o jogador
  }
}

/** Marca, por aba, para qual versão já houve recarga automática. */
const MARCA = 'basquete82.recarga';

/**
 * Recarrega, no máximo uma vez por versão publicada, e só se der.
 *
 * Devolve `false` quando não recarregou — aí quem manda é o aviso na tela.
 */
function recarregarUmaVez(publicada, ocupado) {
  let jaFoi = null;
  try {
    jaFoi = sessionStorage.getItem(MARCA);
  } catch {
    return false;   // sem sessionStorage não há trava anti-laço: não arrisca
  }
  if (jaFoi === publicada) return false;
  if (ocupado()) return false;
  try {
    sessionStorage.setItem(MARCA, publicada);
  } catch {
    return false;
  }
  window.location.reload();
  return true;
}

/**
 * Avisa `onNova` quando houver versão diferente da que está rodando, e
 * recarrega sozinho assim que der.
 *
 * Confere ao iniciar, a cada 10 minutos, e quando a pessoa volta para a aba —
 * é aí que o jogo passa dias aberto e fica para trás.
 *
 * `ocupado()` é perguntado a cada tentativa, e não uma vez só: quem estava no
 * meio de uma partida na primeira checagem é recarregado na seguinte, quando
 * a partida já acabou.
 */
export function vigiarVersao(onNova, ocupado = () => false) {
  if (VERSAO_ATUAL === 'dev') return () => {};
  let avisado = false;

  const conferir = async () => {
    const publicada = await versaoPublicada();
    if (!publicada || publicada === VERSAO_ATUAL) return;
    if (!avisado) { avisado = true; onNova(publicada); }
    recarregarUmaVez(publicada, ocupado);
  };

  conferir();
  const id = setInterval(conferir, 10 * 60 * 1000);
  const aoVoltar = () => { if (document.visibilityState === 'visible') conferir(); };
  document.addEventListener('visibilitychange', aoVoltar);

  return () => {
    clearInterval(id);
    document.removeEventListener('visibilitychange', aoVoltar);
  };
}
